export enum Action {
  ENTER = "ENTER",
  BACKSPACE = "BACKSPACE",
}
